import {
	SET_UPSELL_TOKEN,
} from "./../types";

import { createReducer } from "./functions";

const initialState = {
	token: "",
	logged: false, //logged status
	/**
	 * Eea: 'EEA',
	 * ig: 'FULLNAMEI',
	 * ofa: 'FIRSTNAME',
	 * wea: 'NAME',
	 * Paa: '//photo.jpg',
	 * U3: 'EMAIL'
	 */
	googleData: {}, // google data received from api
	googleScopesGranted: false,
	googleLogged: false,
};

const setUpsellToken = {
	[SET_UPSELL_TOKEN]: (state, action) => {
		return {
			...state,
			token: action.token,
		};
	},
};



const authReducer = createReducer(initialState, {
	...setUpsellToken,
});

export default authReducer;



// WEBPACK FOOTER //
// src/redux/reducers/authReducer.js